module.exports = __webpack_public_path__ + "img/sign-in-bg.513b59a6.jpg";